import React from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

const RightContianer = ({ stickyBanner }) => {
  const { t } = useTranslation();
  return (
    <div className="right-container">
      <div className="right-container-posts">
        <div className="right-post-inside-container">
          <div className="right-post-header">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="icon glyph"
              viewBox="0 0 24 24"
            >
              <path d="M18 11.74a1 1 0 00-.52-.63l-3.39-1.68.91-6.29a1 1 0 00-1.78-.75l-7 9a1 1 0 00-.17.87 1 1 0 00.59.67l4.27 1.71-.91 6.22a1 1 0 00.63 1.07.92.92 0 00.37.07 1 1 0 00.83-.45l6-9a1 1 0 00.17-.81z"></path>
            </svg>
            <p>{t("raffle")}</p>
          </div>
          <div className="urgently-post">text</div>
        </div>

        <div className="right-post-inside-container">
          <div className="right-post-header">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              viewBox="0 0 503.467 503.467"
            >
              <g>
                <path
                  d="M3.33 498.2V276.333h51.2c9.387 0 17.067 7.68 17.067 17.067V481.134c0 9.387-7.68 17.067-17.067 17.067H3.33zM332.716 31.427c15.36-17.067 38.4-28.16 63.147-28.16 46.933 0 85.333 38.4 85.333 85.333 0 51.2-51.2 136.533-145.067 187.733C242.263 225.133 191.063 139.8 191.063 88.6c0-46.933 38.4-85.333 85.333-85.333 11.947 0 23.893 2.56 34.133 6.827 0 0 15.36 8.533 21.333 19.627l.854 1.706z"
                  transform="translate(1 1)"
                ></path>
                <path
                  d="M354.05 399.213c2.56-.853 5.12-1.707 7.68-3.413l98.133-47.787c11.947-6.827 28.16-2.56 34.987 9.387 6.827 11.947 2.56 28.16-9.387 34.987l-115.2 71.68s-25.6 17.067-85.333 17.067c-51.2 0-128-42.667-128-42.667s-17.067-8.533-51.2-8.533H71.596V310.467h102.4c25.6 0 68.267 51.2 93.867 51.2h51.2c17.067 0 25.6 8.533 25.6 8.533s8.533 8.533 8.533 25.6l.854 3.413z"
                  transform="translate(1 1)"
                ></path>
                <path d="M55.53 503.467H4.33c-2.56 0-4.267-1.707-4.267-4.267 0-2.56 1.707-4.267 4.267-4.267h51.2c6.827 0 12.8-5.973 12.8-12.8V294.4c0-6.827-5.973-12.8-12.8-12.8H4.33c-2.56 0-4.267-1.707-4.267-4.267s1.707-4.267 4.267-4.267h51.2c11.947 0 21.333 9.387 21.333 21.333v187.733c0 11.948-9.387 21.335-21.333 21.335zm230.4-17.067c-52.053 0-127.147-41.813-129.707-43.52 0 0-17.067-7.68-49.493-7.68-2.56 0-4.267-1.707-4.267-4.267 0-2.56 1.707-4.267 4.267-4.267 34.987 0 52.053 8.533 52.907 9.387.853.853 76.8 41.813 126.293 41.813 57.173 0 82.773-16.213 82.773-16.213l115.2-71.68c10.24-5.973 13.653-18.773 7.68-29.013-5.973-10.24-18.773-13.653-29.013-7.68l-98.133 47.787c-17.92 9.387-34.987 9.387-69.973 9.387-34.133 0-83.627-8.533-86.187-8.533s-4.267-2.56-3.413-5.12c0-2.56 2.56-4.267 5.12-3.413.853 0 51.2 8.533 84.48 8.533s50.347 0 66.56-7.68l98.133-47.787c13.653-7.68 32.427-3.413 40.107 11.093 8.533 14.507 3.413 32.427-11.093 40.96l-115.2 71.68c-.855-.854-26.455 16.213-87.041 16.213zM25.663 460.8c-5.12 0-8.533-3.413-8.533-8.533s3.413-8.533 8.533-8.533 8.533 3.413 8.533 8.533-3.413 8.533-8.533 8.533zm320-85.333c-.853 0-2.56 0-3.413-.853 0 0-7.68-7.68-22.187-7.68h-51.2c-14.507 0-31.573-12.8-49.493-26.453-16.213-11.947-33.28-24.747-44.373-24.747H106.73c-2.56 0-4.267-1.707-4.267-4.267 0-2.56 1.707-4.267 4.267-4.267h68.267c14.507 0 31.573 12.8 49.493 26.453 16.213 11.947 33.28 24.747 44.373 24.747h51.2c18.773 0 28.16 9.387 29.013 9.387 1.707 1.707 1.707 4.267 0 5.973-.853 1.707-2.56 1.707-3.413 1.707zM337.13 281.6c-.853 0-1.707 0-1.707-.853C243.263 230.4 187.796 144.213 187.796 89.6c0-49.493 40.107-89.6 89.6-89.6 12.8 0 24.747 2.56 35.84 7.68 2.56.853 3.413 3.413 2.56 5.973-.853 2.56-3.413 3.413-5.973 2.56-10.24-4.267-21.333-6.827-32.427-6.827-44.373 0-81.067 36.693-81.067 81.067 0 52.053 52.907 133.973 140.8 182.613 87.893-48.64 140.8-131.413 140.8-182.613 0-44.373-36.693-81.067-81.067-81.067-31.573 0-60.587 18.773-73.387 46.933-.853 2.56-3.413 3.413-5.973 1.707-2.56-.853-3.413-3.413-1.707-5.973C330.303 20.48 362.73 0 396.863 0c49.493 0 89.6 40.107 89.6 89.6 0 54.613-55.467 140.8-147.627 191.147 0 .853-.853.853-1.706.853zM445.503 76.8c-1.707 0-3.413-.853-4.267-2.56-5.12-13.653-15.36-23.893-28.16-28.16-2.56-.853-3.413-3.413-2.56-5.12.853-2.56 3.413-3.413 5.12-2.56 16.213 5.973 28.16 17.92 34.133 34.133.853 2.56 0 4.267-2.56 5.12-.853-.853-1.706-.853-1.706-.853z"></path>
              </g>
            </svg>
            <p>{t("Charity")}</p>
          </div>
          <div className="donation-post">
            <p>text</p>

            <hr />

            <p>text</p>

            <hr />

            <p>text</p>
          </div>
        </div>

        <div className="right-post-inside-container">
          <div className="right-post-header">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                fillRule="evenodd"
                d="M0 11.64C0 4.954 5.24 0 12 0s12 4.953 12 11.64c0 6.689-5.24 11.641-12 11.641-1.214 0-2.38-.16-3.474-.461a.958.958 0 00-.64.048l-2.381 1.05a.962.962 0 01-1.347-.85l-.065-2.134a.967.967 0 00-.324-.683C1.434 18.162 0 15.139 0 11.64zm8.32-2.187l-3.525 5.592c-.34.536.321 1.142.826.758l3.786-2.873a.72.72 0 01.867-.002l2.803 2.103c.84.63 2.043.408 2.603-.48l3.525-5.593c.34-.536-.321-1.142-.826-.758l-3.786 2.873a.72.72 0 01-.867.003l-2.803-2.103a1.802 1.802 0 00-2.603.48z"
                clipRule="evenodd"
              ></path>
            </svg>
            <p>{t("contact")}</p>
          </div>
          <div className="urgently-post"></div>
        </div>
      </div>
      {stickyBanner ? (
        <div className="sticky-banner-container2">
          <a href={stickyBanner.url} target="_blank">
            <img src={stickyBanner.banner_img} alt="sticky-banner" />
          </a>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    stickyBanner: state.management.stickyBanner,
  };
};

export default connect(mapStateToProps, {})(RightContianer);
